var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"star"},_vm._l((_vm.nums),function(item){return _c('span',{key:item,ref:"myCanvas",refInFor:true,style:({
      left: parseInt(Math.random() * _vm.screenW) + 'px',
      top:
        _vm.$store.state.isMobile == 'web'
          ? parseInt(Math.random() * _vm.heights) + 'px'
          : parseInt(Math.random() * _vm.heights) / 100 + 'rem',
      animationDelay: Math.random() + 's',
      transform: `scale(${(Math.random() / _vm.scalex + 0.01, Math.random() / _vm.scaley + 0.01)})`,
    })},[_c('img',{attrs:{"src":require("../assets/images/star.png")}})])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }